import { ImageResource } from "pixi.js";
import { CreateElement, Scale, Size } from "../../../MyHelpers";
import { Translator } from "../../../Translator";
import { IReadOnlyResourceManager, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { PlayWindow, Symbol, SymbolType } from "../../../api";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { PixiSpriteResource } from "../../../ResourceManager/PixiSpriteResource";
import { CanvasSprite } from "../../Sprite/CanvasSprite";
import { Resourceful } from "../../../ResourceManager/Resourceful";
import { ICombination, IGroup } from "../PayTable8Squares";
import { SlotGameMessages } from "../../SlotGameScreenMessages";
import { WinsMap } from "../PayTable9Squares";
//import { MyCanvas } from "../../MyCanvas";
import { SlotSymbol } from "../../SlotSymbol";
import { SlotSymbolSprite } from "../../SlotSymbolSprite";
import { IInterval } from "../../../Context/Interval";
import { ISystemContext } from "../../../Context/SystemContext";
import { SymbolsCollectionResources } from "../../SpineSymbols/SymbolsCollection";

export interface WildBulkSlidePaytableParams {
    translator: Translator,
    wildSymbol: Symbol,
    wildInReel: number[],
    scattersTrigger: string[],
    resid: ResourceIdentifier,
    groupData: IGroup,
    slotSymbolsData: SlotSymbol[],
    //symbolSpriteAnims: SlotSymbolSprite[],
    playWindow: PlayWindow,
    systemContext: ISystemContext,
    playlines: number[][],
    symbolsCollection : Map<string,SymbolsCollectionResources>,
}

export class WildBulkSlide implements Resourceful {
    protected view: HTMLElement;
    protected translator: Translator = null;
    protected imgBackground: ImageResource = null;
    protected wildSymbol: Symbol = null;
    protected wildInReel: number[] = null;
    protected scattersTrigger: string[] = [];
    protected resid: ResourceIdentifier = null;
    protected slides: HTMLElement[] = [];
    protected groupData: IGroup = null;
    protected winsToUpdate: WinsMap[] = [];
    protected mainConatiner1: HTMLElement = null;
    protected mainConatiner2: HTMLElement = null;
    protected slotSymbolsData: SlotSymbol[] = [];
    //protected symbolSpriteAnims: SlotSymbolSprite[] = [];
    //protected canvas: MyCanvas = null;
    protected wildSlideTimer: IInterval;
    protected playWindow: PlayWindow = null;
    protected systemContext: ISystemContext = null;
    protected totalWinsToUpdate: WinsMap = null;
    protected playlines: number[][] = [];
    readonly symbolsCollection : Map<string,SymbolsCollectionResources> = null;
    constructor(params: WildBulkSlidePaytableParams) {

        this.symbolsCollection = params.symbolsCollection;

        this.view = CreateElement("div", {
            classes: ["paytable-symbol-container"],

            style: {
                display: "flex",
                //flexDirection: "row",
                width: "100%",
                height: "100%",
                //position: "relative",
            }
        });
        this.wildSymbol = params.wildSymbol;
        this.wildInReel = params.wildInReel;
        this.scattersTrigger = params.scattersTrigger;
        this.resid = params.resid;
        this.translator = params.translator;
        this.groupData = params.groupData;
        //this.symbolSpriteAnims = params.symbolSpriteAnims;
        this.slotSymbolsData = params.slotSymbolsData;
        this.systemContext = params.systemContext;
        this.playWindow = params.playWindow;
        // this.playWindow = {
        //     Width : 7,
        //     Height : 4,
        //     NumOfSymbols : 0,
        // };
        this.playlines = params.playlines;      
        params = null;
    }
    PrepareResources(resourceManager: ResourceManager) {
        throw new Error("Method not implemented.");
    }
    //create everything 
    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        this.Slide1(resourceManager);
        //flag for disable setBet to slide2
        if (this.groupData.Pays.length > 0 && this.wildInReel.length == this.playWindow.Width && this.wildSymbol.SymbolType == "ExpandingWildBulk") {
            this.Slide2(resourceManager);
            
            //Create Some interval 

            this.wildSlideTimer = this.systemContext.TimingContext().CreateInterval("wildSlideTimer", 5000, () => this.ChangeSlider());
        }


    }


    protected currentIndexSlide: number = 1;
    protected ChangeSlider()
    {
        let nextSideIndex = (this.currentIndexSlide + 1) % this.slides.length;
        this.slides[nextSideIndex].style.display = "block";
        this.slides[this.currentIndexSlide].style.display = "none";               
        this.currentIndexSlide = nextSideIndex; 
    }

    //------------------------------------------------- Create Slide 1 -------------------------------------------------
    //create slider for show wild combinations
    protected Slide1(resourceManager: IReadOnlyResourceManager) {
        let slide1 = CreateElement("div", {
            classes: ["paytable-slide1"],
            parentToAppend: this.view,
            style: {
                display: "flex",
                //position: "absolute",
                width: "100%",
                height: "100%",
            }
        });

        this.mainConatiner1 = CreateElement("div", {
            classes: ["paytable-mainconatinaer-slide1"],
            parentToAppend: slide1,
            style: {
                display: "grid",
                // flexDirection: "column",
                // flexWrap: "wrap",
                width: "100%",
                borderRadius: Scale.XYpx(25),
                height: "100%",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                alignItems: "center",
                justifyContent: "center",
            }
        });

        this.symbolAndCombinationCont = CreateElement("div", {
            classes: ["symbolAndCombinationCont",],
            parentToAppend: this.mainConatiner1,
            style: {
                position:"inherit",
                width:"100%",
                height: "100%",

            }
        });

        this.CreateSymbolImg();
        this.CreateDescription(resourceManager);
        this.CreateCombination(this.groupData.Pays);        
        this.slides.push(slide1)
        slide1 = null;
    }

    protected symbolAndCombinationCont: HTMLElement = null;
    //create SymbolImg 
    protected CreateSymbolImg() {

        //create symbol container 
        let imgContainer = CreateElement("div", {
            classes: ["img-container",],
            parentToAppend: this.symbolAndCombinationCont,
            style: {
                //height: Scale.H(280) + "px",
                width: Scale.W(320) + "px",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                //background: "red",
                left: Scale.Ypx(-247),
                top: "-30%",//Scale.Ypx(-10),
                
            }
        });



        let symbols = this.groupData.Symbols;
        let symbol_number = 0;
        let symbolSize = new Size(Scale.W(320), Scale.H(280));
        //will works ok if dont have wild on that group
        //create symbols
        for (let index = 0; index < symbols.length; index++) {

            let symbol = CreateElement("div", {
                classes: ["symbol", "paytable-symbol-" + symbol_number.toString()],
                parentToAppend: imgContainer,
                style: {
                    display: "flex",
                    flexDirection: "column",
                }
            });

            let PaytableSymbolImage = CreateElement("div", {
                classes: ["paytable-symbol-image", "image"],
                parentToAppend: symbol,
                style: {
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",

                }
            });

            symbol_number++;
            //create symbol 
            //this.canvas = new MyCanvas(symbolSize);
            //this.canvas.push(canvas);
            //PaytableSymbolImage.appendChild(this.canvas.view);

            let imgHTML = this.symbolsCollection.get("Symbol_"+symbols[index]).imgResource.cloneNode(true) as HTMLSpanElement;
            const symbolSize = new Size(Scale.W(320), Scale.H(280));
            imgHTML.style.width = symbolSize.Width + "px";
            imgHTML.style.height = symbolSize.Height + "px";
            
            PaytableSymbolImage.appendChild(imgHTML);

            symbol = null;
            PaytableSymbolImage = null;
        }
        imgContainer = null;
        symbols = null;
        symbolSize = null
    }
    //create Description for Wild
    protected CreateDescription(resourceManager: IReadOnlyResourceManager) {
        let descriptionContainerSymbolType = CreateElement("div", {
            classes: ["symbol-container-descriptionContainerSymbolType", `Wild`],
            parentToAppend: this.mainConatiner1,
            style: {
                display: "flex",
                position: "absolute",              
                width: "100%",
                height: "35%",
                alignItems: "center",
                justifyContent: "center",               
            }
        });

        let descriptiontextSymbolType = CreateElement("div", {
            classes: ["descriptiontextSymbolType"],
            parentToAppend: descriptionContainerSymbolType,
            style: {
                position:"absolute",
                display:"block",
                width: "85%",
                height: "25%",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                //verticalAlign: "middle",
                textShadow: `0px 0px ${Scale.fhpx(5)} black,0px 0px ${Scale.fhpx(10)} black,0px 0px ${Scale.fhpx(15)} black,0px 0px ${Scale.fhpx(40)} black`,
                color: "white",
                fontSize: Scale.fhpx(20),
                textAlign: "center",
                lineHeight: Scale.fhpx(25),
                
            }
        });

        //create string for paytable wild info 
        let stringElement: string = "\n";
        //show img if you have some  bonusTriggered enabled
        if (this.scattersTrigger) {            
           
            let ImgElement = this.DrawSymbolImage(resourceManager, this.scattersTrigger, new Size(Scale.W(50), Scale.H(50)));

            ImgElement.forEach((ele, index) => {
                ele.style.width = "20%";
                ele.style.height = "20%";
                stringElement += ele.innerHTML
                if (index < ImgElement.length - 1) {
                    stringElement += ","
                }
                ele = null;
                index = null;
            });
            ImgElement = null;
            this.scattersTrigger = null;
        }



        if (this.wildSymbol.SymbolType == "ExpandingWildBulk") {
            let translatedMessage = this.translator.Translate(() => this.translator.t.wildBulkPaytableMessage(this.wildInReel, stringElement));
            descriptiontextSymbolType.appendChild(translatedMessage.location);
        }
        else if (this.wildSymbol.SymbolType == "ExpandingWildReel") {
            let translatedMessage = this.translator.Translate(() => this.translator.t.wildReelPaytableMessage(stringElement));
            descriptiontextSymbolType.appendChild(translatedMessage.location);
        }
        else {
            //let translatedMessage = this.translator.Translate(() => this.translator.t.wildBulkPaytableMessage(this.wildInReel, stringElement));
            //descriptiontextSymbolType.appendChild(translatedMessage.location);
        }
        //descriptionContainerSymbolType = null;
        //descriptiontextSymbolType = null;
        //stringElement = null;
    }
    //create Combination
    protected CreateCombination(Pays: ICombination[]) {
        //create combination for wild group
        let paytableCombinations = CreateElement("div", {
            classes: ["paytable-combinations"],
            parentToAppend: this.symbolAndCombinationCont,
            style: {
                //display: "flex",
                //flexDirection: "column",
                //justifyContent: "center",
                fontFamily: "Arial",
                fontWeight: "normal",
                position: "absolute",
                lineHeight: Scale.fhpx(52),
                textAlign: "left",
                //right: Scale.Xpx(60),
                //height: "100%",
                marginRight: Scale.Xpx(20),
                right: Scale.Xpx(30),
                top:"25%"
            }

        });      

        //let combinations = this.paytable[symbol_number].Combinations;
        for (let indexPays = 0; indexPays < Pays.length; indexPays++) {
            let paytableCombination = CreateElement("div", {
                classes: ["paytable-combination-" + indexPays],
                parentToAppend: paytableCombinations,
                style: {
                    display: "flex",
                    flexDirection: "row",
                    fontWeight: "bold",
                    verticalAlign: "middle",
                    textShadow: `0px 0px ${Scale.fhpx(5)} black,0px 0px ${Scale.fhpx(10)} black,0px 0px ${Scale.fhpx(15)} black,0px 0px ${Scale.fhpx(40)} black`,
                    flexShrink: "2",
                    position: "relative",
                    alignItems: "center",
                }
            });

            let paytableOcurrence = CreateElement("div", {
                classes: ["paytable-occurence"],
                parentToAppend: paytableCombination,
                style: {
                    fontSize: Scale.fhpx(50),
                    color: " #f49b42",
                    textAlign: "left",
                }
            });

            paytableOcurrence.innerText = Pays[indexPays].Count.toString() + "x";

            // this is win, this updates
            let paytableRewad = CreateElement("div", {
                classes: ["paytable-reward"],
                parentToAppend: paytableCombination,
                style: {
                    fontSize: Scale.fhpx(Math.max(50 - (indexPays * 7), 30)),
                    color: " white",
                    textAlign: "center",
                    flexGrow: "1",
                }
            });

            this.winsToUpdate.push({
                symbolType: SymbolType.Wild,
                groupName: this.groupData.Name,
                payIndex: indexPays,
                winElement: paytableRewad
            });
            paytableRewad.innerText = " " + Pays[indexPays].WinCredits.toString();
            paytableRewad = null;
            paytableCombination = null;
            paytableOcurrence = null;              
        }
        paytableCombinations = null;
    }

    ////------------------------------------------------- Finish Slide 1 -------------------------------------------------


    //------------------------------------------------- Create Slide 2 ------------------------------------------------- 
    //create slider for show all Win   
    protected Slide2(resourceManager: IReadOnlyResourceManager) {
        let slide2 = CreateElement("div", {
            classes: ["paytable-slide2"],
            parentToAppend: this.view,
            style: {
                display: "none",
                position: "absolute",
                width: "100%",
                height: "100%",
            }
        });

        let mainconatinaer2 = CreateElement("div", {
            classes: ["paytable-mainconatinaer-slide2"],
            parentToAppend: slide2,
            style: {
                display: "flex",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
            }
        });

        let stringElement = "\n";
        let symbolsSize = new Size(Scale.W(Math.max(90 - (this.playWindow.Width * this.playWindow.Height), 46 - (this.playWindow.Width * this.playWindow.Height))), Scale.H(Math.max(85 - (this.playWindow.Width * this.playWindow.Height), 46 - (this.playWindow.Width * this.playWindow.Height))))
        //console.log(`PaytableSymbolsSize ${this.resid.Scope()}  CountSymbols:${this.playWindow.Width * this.playWindow.Height}   Height:${this.playWindow.Height} Width:${this.playWindow.Width} MaxSymbolSize:${Scale.W(Math.max(95 - (this.playWindow.Width * this.playWindow.Height ), 46 -(this.playWindow.Width * this.playWindow.Height)))}`)
        let ImgElement = this.DrawSymbolImage(resourceManager, ["Wild"], symbolsSize);
        ImgElement.forEach((ele, index) => {
            stringElement += ele.innerHTML
            if (index < ImgElement.length - 1) {
                stringElement += ","
            }
        }); 

        //create table 
        let symbolsTable = CreateElement("table", {
            parentToAppend: mainconatinaer2,
            style: {
                width: "55%",
                height: "70%",
                //justifyContent : "center",
                alignContent: "center",
                //bottom: Scale.Ypx(-19),
                //left: Scale.Ypx(33),
                //position: "relative",
            }
        });

        for (let reel = 0; reel < this.playWindow.Height; reel++) {
            let reelElement = CreateElement("tr", {
                parentToAppend: symbolsTable,
                style: {
                    width: "100%",                   
                    display: "flex",
                    justifyContent: "center",
                }
            });
            for (let row = 0; row < this.playWindow.Width; row++) {
                let rowElement = CreateElement("td", {
                    parentToAppend: reelElement                   
                });              
                rowElement.appendChild(ImgElement[0].cloneNode(true));             
                rowElement = null;

            }
            reelElement = null
        }
        symbolsTable = null;

        let paytableCombinations = this.CreateAllWinCombination(this.groupData.Pays);
        mainconatinaer2.appendChild(paytableCombinations);
        this.slides.push(slide2);
        mainconatinaer2 = null;
        slide2 = null;
        paytableCombinations = null;
    }
    //create Wild win total 
    protected CreateAllWinCombination(Pays: ICombination[]): HTMLElement {
        //create combination for wild group
        let paytableCombinations = CreateElement("div", {
            classes: ["paytable-combinations"],
            parentToAppend: this.symbolAndCombinationCont,
            style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                fontFamily: "Arial",
                fontWeight: "normal",
                position: "absolute",
                lineHeight: Scale.fhpx(60),
                textAlign: "left",
                //right: Scale.Xpx(60),
                height: "100%",
                width: "55%",
                marginRight: Scale.Xpx(20),
                //right: Scale.Xpx(30),
            }

        });

        let paytableCombination = CreateElement("div", {
            classes: ["paytable-combination"],
            parentToAppend: paytableCombinations,
            style: {
                display: "flex",
                flexDirection: "row",
                fontWeight: "bold",
                verticalAlign: "middle",
                textShadow: `0px 0px ${Scale.fhpx(5)} black,0px 0px ${Scale.fhpx(10)} black,0px 0px ${Scale.fhpx(15)} black,0px 0px ${Scale.fhpx(40)} black`,
                flexShrink: "2",
                position: "relative",
                alignItems: "center",
            }
        });

        // this is win, this updates
        let paytableRewad = CreateElement("div", {
            classes: ["paytable-reward"],
            parentToAppend: paytableCombination,
            style: {
                fontSize: Scale.fhpx(72),
                color: " white",
                textAlign: "center",
                flexGrow: "1",
            }
        });       

        this.totalWinsToUpdate = {
            symbolType: SymbolType.Wild,
            groupName: this.groupData.Name,
            payIndex: 0,
            winElement: paytableRewad
        }
        return paytableCombinations
    }
    //------------------------------------------------- Finish Slide 2 -------------------------------------------------


    //** its use for create simple img  */
    protected DrawSymbolImage(resourceManager: IReadOnlyResourceManager, symbolNames: string[], symbolsSize: Size): HTMLElement[] {
        let imgBonusTrigger: HTMLElement[] = [];
        symbolNames.forEach((name) => {
            //take symbol from resources manager
            let sprite = resourceManager.Get<PixiSpriteResource>(this.resid.Add("Symbol").Add(name).Shared()).sprite;

            //create canvas whit img for take frame 0 
            let symbolsSprite = new CanvasSprite({
                sprite: sprite,
                canvasSize: symbolsSize
            });

            symbolsSprite.Update(true);
            //return data saved from  img from canvas
            let dataCanvas = symbolsSprite.PreviewImage();
            let spanImg = CreateElement("span", {
                style: {
                    //width: symbolsSize.width + "px",
                    //height: symbolsSize.height + "px",
                    //backgroundImage: dataCanvas,
                }
            });

            //create img div empty
            let imgConverted = CreateElement("img", {
                style: {
                    // width: symbolsSize.width + "px",
                    // height: symbolsSize.height + "px",
                    // backgroundPosition: "center",
                    // backgroundSize: "contain",
                    // backgroundOrigin: "center",
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    width: "15%",
                }
            });
            //add img src from data img saved 
            imgConverted.src = dataCanvas;
            spanImg.appendChild(imgConverted);
            imgBonusTrigger.push(spanImg);

            //put everything null for clean memory 
            sprite = null;
            symbolsSprite = null;
            dataCanvas = null
            spanImg = null;
            imgConverted = null;
        });
        return imgBonusTrigger
    }
    //** its for set bet and change value for wild group combination */
    public SetBet(message: SlotGameMessages.BetChange) {
        let bet = message.bet;
        //let totalBet = message.betTotalCredit;
        for (let s = 0; s < this.winsToUpdate.length; s++) {
            let winToUpdate = this.winsToUpdate[s];
            let win: number = 0;
            {
                win = this.groupData.Pays[winToUpdate.payIndex].WinCredits * bet;
                winToUpdate.winElement.innerText = win.toString();
            }
        }
        //flag for disable setBet to slide2
        if ( this.totalWinsToUpdate != null ) {
            let AllwinWild: number = 0;
            {
                AllwinWild = this.groupData.Pays[0].WinCredits * bet;
                this.totalWinsToUpdate.winElement.innerText = (AllwinWild * this.playlines.length).toString();
            }
        }
    }
    //** return main container  */
    public View(): HTMLElement {
        return this.view;
    }
    //**start slider for wildGroup timer */
    public StartAnim() {
        this.wildSlideTimer?.Start();
    }
    //**start slider for wildGroup timer */
    public StopAnim() {
        this.wildSlideTimer?.Stop();
    }
    //anim symbol paytable
    public Update(force: boolean = false): void {
        //let symbolsnames: string = "Wild";
        //let i = this.slotSymbolsData.find(s => s.ID == symbolsnames);
        //if (symbolsnames.includes("Wild") == false) {
        //if (this.symbolSpriteAnims[i.Index].Sprite().FrameChanged() || this.canvas.WasContextLost() || force) {
       // this.canvas.RestoreContext();
        //this.symbolSpriteAnims[i.Index].Draw(this.canvas);
        //}
        //}
    }
}